export const ADMIN_ADDRESS = "J69nhVXD7cFWNJcJUPqKrFdNezptGmss2XbLDu6hzyJX";
export const PROJECT_VAULT_ADDRESS = "9rt5ininiXa8GMHBuH1CjERn8fafX7HUn9sMqZwNWTcf";
export const SOL = "solana";
export const USDC = "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v";
export const USDC_MINT = "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v";
export const USDT_MINT = "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB";
export const SERVICE_URL = "https://pay.poofy.ai";
export const DEFAULT_EXPIRY_SECONDS = "1800";
export const MAX_EXPIRY_SECONDS = "86400";
export const DEMO_TENANT_APPID = "poofy-pay-demo";
export const PHANTOM_APP_ID = "c6db8bcd-379f-47a5-829f-2aed09d51d87";
